import { Accordion, AccordionSummary, AccordionDetails, Paper } from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";

import DefaultNavbar from "../../components/TopNavBar/DefaultNavBar";
import Visualization from "../../components/Visualization";
import Root  from "../../views/Root";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import { useState } from "react";

function ProjectRelationshipsOverview() {
    const [hierarchyDiagramExpanded, setHierarchyDiagramExpanded] = useState(true);
    const [networkDiagramExpanded, setNetworkDiagramExpanded] = useState(false);

    return (
        <DashboardLayout>
            <DefaultNavbar />
            <MDBox sx={{width: "100%"}}>
                <Paper sx={{width: "100%", p: 1, borderRadius: 2, backgroundColor: "navy.main"}}>
                    <Accordion expanded={hierarchyDiagramExpanded} onChange={() => setHierarchyDiagramExpanded(!hierarchyDiagramExpanded)} sx={{mb: 1}}>
                        <AccordionSummary expandIcon={<ExpandMore/>}>
                            <MDTypography variant="h5">Hierarchy Diagram</MDTypography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <MDBox sx={{width: "100%", height: "100%", border: "1px solid #000000"}}>
                                <Visualization />
                            </MDBox>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={networkDiagramExpanded} onChange={() => setNetworkDiagramExpanded(!networkDiagramExpanded)}>
                        <AccordionSummary expandIcon={<ExpandMore/>}>
                            <MDTypography variant="h5">Network Diagram</MDTypography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <MDBox sx={{
                                width: "100%", 
                                height: "800px",
                                border: "1px solid #000000",
                                position: "relative",
                                backgroundColor: "white"
                            }}>
                                {/* <Visualization /> */}
                                <Root />
                            </MDBox>
                        </AccordionDetails>
                    </Accordion>
                </Paper>
            </MDBox>
        </DashboardLayout>
    );
}

export default ProjectRelationshipsOverview;